import { FC } from "react"
import { useFormikContext} from "formik"
import * as Yup from 'yup'
import { 
  FormikFileUpload,
  ApplicationFileDownload,
  FormikNotesArea
} from "../../../../../components/widgets"

import { DLMDOC } from "../../../../core/doclabel"
import { sortBy } from "lodash"

  
export const initDLMSubmitSignedDOCValues = {
  docModels: [],
  note: '',
  noteAttachments: [],    
}

export const DLMSubmitSignedDOCSchema = Yup.object({
  docModels: Yup.array().of(
    Yup.object().shape({
      docId: Yup.number().integer().label('DOC Id'),
      docAttachmentId: Yup.number().integer().moreThan(0,'DOC required').required().label('DOC Attachment'),
      docAttachmentIdAttachmentName: Yup.string().trim(),
    })
  ).min(1, 'DOC Required').required(),    
  note: Yup.string().trim().label('Note'),  
  noteAttachments: Yup.array(),    
})

type Props = {
  docs: Array<DLMDOC>
}

const DLMSubmitSignedDOCForm: FC<Props> = ({docs}) => {

  const { validateField } = useFormikContext();    
  return (
  <>    
  <h4>Upload Signed DOC:</h4>
  <div className='text-muted fs-7'>Please dowload and endorse before submitting.</div>                           
  <div className='separator border-gray-200 mb-2'></div>        
  <div className="mh-300px overflow-auto pe-4"> {
    sortBy(docs, 'cbRef').map((docModel: any, idx: number) => (
    <div key={`setDOCrow_${idx}`} className="row">
      <div className="col-5 py-2">        
        { docModel.draftDOCFile && 
        <>
        <div className="text-muted fs-7">Draft DOC</div>
        <ApplicationFileDownload file={docModel.draftDOCFile} />
        </>
        } 
      </div>             
      <FormikFileUpload 
        size="7" 
        label={`${docModel?.cbRef ? docModel.cbRef : 'Signed DOC'}`} 
        name={`docModels.${idx}.docAttachmentId`} 
        acceptFiles="ApplicantFileFormats" 
        required={true}   
        subTitle="Upload signed DOC here."   
        onUpdateFunc={ () => {
            validateField('docModels');
        }}                   
      />
    </div>
  ))}
  </div>            
  <div className='separator border-gray-200 my-4'></div>

  <FormikNotesArea />        
  
  </>
  )
}

export { DLMSubmitSignedDOCForm }